<template>
  <div id="app">
    <topbar v-if="form" v-show="$route.name === 'Registration'"></topbar>
    <main role="main">
      <router-view />
    </main>
    <bottombar v-if="form" v-show="$route.name === 'Registration'"></bottombar>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import topbar from "./components/shared/topbar/topbar.vue";
import bottombar from "./components/shared/bottombar/bottombar";

export default {
  name: "app",
  components: {
    topbar,
    bottombar
  },
  computed: {
    ...mapGetters({
      form: "getActiveForm",
      userInfo: "getUserData"
    })
  },
  methods: {
    ...mapActions({
      setActiveForm: "setActiveForm",
      setComponents: "setComponents",
      setActiveRegistration: "setActiveRegistration",
      setupRegistrationData: "setupRegistrationData"
    })
  },
  created() {
    console.log("Getting into created in App.vue ...:");
    return new Promise(resolve => {
      // Get request fomId and appKey for retrieving correct form
      resolve(
        this.setupRegistrationData({
          formId: localStorage.getItem("formId"),
          apiKey: localStorage.getItem("apiKey"),
          revisionNo: localStorage.getItem("revisionNo")
        })
      );
    }).then(() => {
      let listComponents = [
        {
          id: 1,
          index: 0,
          name: "intro-page",
          active: true,
          disabled: false
        },
        {
          id: 2,
          index: 1,
          name: "form-registration",
          active: false,
          disabled: false
        },
        {
          id: 3,
          index: 2,
          name: "map-component",
          active: false,
          disabled: this.form.mapEnabled ? false : true
        },
        {
          id: 4,
          index: 3,
          name: "file-upload",
          active: false,
          disabled: this.form.photoEnabled ? false : true
        }
      ];

      this.setComponents(listComponents);

      // Global errorhandling
      window.onerror = function(msg, url, lineNo, columnNo, error) {
        let payload = {
          clientErrorLogId: "",
          logCreatedDateTime: "0001-01-01T00:00:00",
          userData: {
            customerUserId: "59a92ab0ae7a711b38901763",
            customerId: this.userInfo._id,
            name: "public",
            email: null
          },
          appInfo: {
            appId: "",
            appName: "Kollecto Public",
            appVersionId: null,
            apiVersion: null,
            dbVersion: null
          },
          exceptionMessage: "Test fejl errorlog 2 ....",
          exceptionUrl: null,
          formId: "5ba3f074e55fbc1b84efef63",
          registrationId: "5bc46456e55fbc51d41ed98a"
        };

        let errMsg = [
          "Message: " + msg,
          "URL: " + url,
          "Line: " + lineNo,
          "Column: " + columnNo,
          "Error object: " + JSON.stringify(error)
        ].join(";");

        payload.exceptionMessage = errMsg;
        this.setErrorLog(payload);
      };
    });
  }
};
</script>

<style lang="scss">
@import "./styles/main.scss";
</style>
